// "Select a size" gate, "adding" state, and the cart rail.
(() => {
  const SELECT = 'Select a size', ADD = 'Add to cart', ADDING = 'Adding';
  const buttonSelector = '.add-to-cart-button, .sticky-add-to-cart__button';
  const sizeFieldset = () => [...document.querySelectorAll('variant-picker[data-template-product-match] fieldset')]
    .find((f) => /^\s*size/i.test(f.querySelector('legend')?.textContent || ''));
  const inPageButtons = () => [...document.querySelectorAll(buttonSelector)]
    .filter((b) => !b.closest('#cart-drawer, quick-add-component, .quick-add-modal, dialog'));
  const setLabel = (button, text) => {
    const node = [...button.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
    if (node) node.textContent = ` ${text} `;
  };

  let sizeChosen = new URLSearchParams(location.search).has('variant') || !sizeFieldset();
  const applyGate = () => {
    if (sizeChosen) return;
    sizeFieldset()?.querySelectorAll('input[type=radio]').forEach((i) => { i.checked = false; });
    inPageButtons().forEach((b) => setLabel(b, SELECT));
  };
  applyGate();
  // The theme rewrites the button label after load when this dress is already in the cart.
  window.addEventListener('load', () => setTimeout(applyGate, 800));

  document.addEventListener('change', (e) => {
    if (e.target.matches?.('input[type=radio]') && e.target.closest('fieldset') === sizeFieldset()) {
      sizeChosen = true;
      inPageButtons().forEach((b) => setLabel(b, ADD));
    } else if (e.target.matches?.('[data-rs-color] input')) {
      [700, 1500].forEach((ms) => setTimeout(applyGate, ms));  // the theme redraws the picker after a color change
    }
  }, true);

  document.addEventListener('click', (e) => {
    const button = e.target.closest?.(buttonSelector);
    if (button && inPageButtons().includes(button)) {
      if (!sizeChosen) {
        e.preventDefault();
        e.stopImmediatePropagation();
        sizeFieldset()?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      setLabel(button, ADDING);
      const started = Date.now();
      const timer = setInterval(() => {
        if (document.querySelector('#cart-drawer dialog[open]') || Date.now() - started > 4000) {
          clearInterval(timer);
          setLabel(button, ADD);
        }
      }, 100);
    }

    const tab = e.target.closest?.('[data-rs-tab]');
    if (tab) {
      const guide = tab.closest('.rs-sg');
      guide.querySelectorAll('[data-rs-tab]').forEach((b) => b.classList.toggle('is-active', b === tab));
      guide.querySelectorAll('[data-rs-panel]').forEach((p) => { p.hidden = p.dataset.rsPanel !== tab.dataset.rsTab; });
    }

    const railAdd = e.target.closest?.('[data-rs-rail-add]');
    if (railAdd) {
      railAdd.hidden = true;
      railAdd.parentElement.querySelector('.rs-rail__sizes').hidden = false;
    }
    const railVariant = e.target.closest?.('[data-rs-rail-variant]');
    if (railVariant) addFromRail(railVariant);
  }, true);

  async function addFromRail(button) {
    const card = button.closest('[data-rs-rail-card]');
    card.style.opacity = '.5';
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(button.dataset.rsRailVariant), quantity: 1, sections: 'cart-drawer-section' }),
    });
    const data = await response.json();
    card.style.opacity = '';
    if (!response.ok) return;
    const html = new DOMParser().parseFromString(data.sections['cart-drawer-section'], 'text/html');
    const fresh = html.querySelector('.cart-drawer__inner');
    if (fresh) document.querySelector('#cart-drawer .cart-drawer__inner')?.replaceWith(fresh);
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('.cart-bubble').forEach((b) => b.classList.remove('visually-hidden'));
    document.querySelectorAll('.cart-bubble__text-count').forEach((c) => {
      c.textContent = cart.item_count;
      c.classList.remove('hidden');
    });
    card.querySelector('.rs-rail__sizes').hidden = true;
    card.querySelector('[data-rs-rail-add]').hidden = false;
  }
})();
/* rue-sable ships-by */
(() => {
  const HOLIDAYS = new Set(["2026-11-11", "2026-11-26", "2026-12-25", "2027-01-01", "2027-01-18", "2027-02-15", "2027-05-31", "2027-06-18", "2027-07-05", "2027-09-06", "2027-10-11", "2027-11-11", "2027-11-25", "2027-12-24", "2027-12-31"]);
  const HANDLING = 3;
  const ymd = (d) => d.toISOString().slice(0, 10);
  const isBiz = (d) => d.getUTCDay() > 0 && d.getUTCDay() < 6 && !HOLIDAYS.has(ymd(d));
  function shipsBy(now = new Date()) {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', {timeZone: 'America/New_York', hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit'}).formatToParts(now).map((x) => [x.type, x.value]));
    let d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    if (!isBiz(d) || +p.hour >= 18) { do { d.setUTCDate(d.getUTCDate() + 1); } while (!isBiz(d)); }
    for (let left = HANDLING; left > 0;) { d.setUTCDate(d.getUTCDate() + 1); if (isBiz(d)) left--; }
    return d.toLocaleDateString('en-US', {timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'});
  }
  window.rsShipsBy = shipsBy;
  const paint = () => document.querySelectorAll('[data-rs-ships]').forEach((el) => {
    el.querySelector('[data-rs-ships-date]').textContent = shipsBy(); el.hidden = false; });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', paint) : paint();
})();
